import { belongsTo, Factory, Model } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import type { SchemaAttributes } from '@@/api/types'
import { rand, randRecentDate } from '@ngneat/falso'

type InvoiceEventLogAttributes = SchemaAttributes<'InvoiceEventLog'>

export const model = Model.extend({
  invoice: belongsTo('invoice'),
  createdUser: belongsTo('user'),
}) as ModelDefinition<InvoiceEventLogAttributes>

export const factory = Factory.extend<InvoiceEventLogAttributes>({
  event_type() {
    return rand(['EVENT_LOG_SENT_BY_EMAIL', 'EVENT_LOG_SENT_BY_POST'])
  },
  created() {
    return randRecentDate().toISOString()
  },
  modified() {
    return randRecentDate().toISOString()
  },
})
